import React, { memo, useCallback, useEffect, useRef, useState } from 'react'
import cogoToast from 'cogo-toast-react-17-fix';

import API from '../../../../ApiConfig'
import { GET_ALL_COMPANIES, VERIFIER_SEARCH, BASE_URL, USER_TOKEN, GET_FORM_DETAILS, GET_COMPANY_LIST, SEARCH_EMP_RECORDS, GET_VERIFIER_BANNER, GET_TEMPLATE_FIELDS_FOR_PREFILL } from '../../../../Utils/constant'
import SlideUpWrapper from '../../../../components/Transitions/SlideUpWrapper';

import ShimmerLoader from '../../../../components/ShimmerLoader';
import styles from '../Verifier/VerifyUsers.module.css'
import { _ToNormal } from '../../../../Utils/helper';
import useRefreshToken from '../../../../Hooks/usegenerateToken';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import RecipientsDetails from './recipientsDetails';
import DisplayResult from './displayResult';
import IssuerNavigator from '../../../../components/DashBoard/IssuerNavigator';
import CompanySearch from './companyDetails';
import TopTitleBar from '../TopTitleBar';
import SearchDropdown from './searchDropdown';
import CartPopupModel from '../../../Cart/CartPopupModel';



const DATELABELS = ["Date Of Joining", "Date Of Exit"]
const isDateOption = (field) =>
    typeof field.label === "string" && DATELABELS.includes(field.label.trim())

export default function EmpSearch({ id }) {
    useRefreshToken(BASE_URL + USER_TOKEN)
    const userData = useSelector(state => state.User)

    const location = useLocation()
    // const form = location.state.form || null
    const [loading, setLoading] = useState(false)
    const [Issuers, setIssuers] = useState([])
    const [companyList, setCompanyList] = useState([])

    const [fieldsData, setFieldsData] = useState([])
    const [loadShimmer, setLoadshimmer] = useState(0)


    const [result, setresult] = useState()

    const [company, setCompany] = useState([]);
    const [onbehalf, setOnBehalf] = useState([]);
    const [doc, setDoc] = useState();

    const [documentData, setDocumentData] = useState([]);
    const [Other, setOther]=useState('')

    const [showBanner, setShowBanner]=useState(false)


    const [newBannerText, setNewBannerText]=useState("")
    const [showPopup, setShowPopup]=useState(false)
    const User=useSelector(state=>state.User)
    const [arsNo, setArsNo]=useState("")


    const [templateFields, setTemplateFields]=useState(null)

    const [isRecordFound, setIsRecordFound]=useState(true)


    const[isSubmit, setIsSubmit]=useState(false)
    const[isFormValid, setIsFormValid]=useState(null)
    const [masterTemplate_id, setMasterTemplateId]=useState(null)
    const [IsDataSearched, setIsDataSearched]=useState(false)
    const [employmentType, setEmploymentType]=useState("")
    
    
    useEffect(() => {
        getAllIssuers()
        // getFormDetails()

    }, [])

    async function getFormDetails() {
        setLoading(true)
        API.get(`${GET_FORM_DETAILS}?verifier_id=${User.id}`)
            .then(res => {
                // setData(res.data.data)
                // console.log();
                // white collor-2, blue collor-1, normal-0
                setDocumentData(res.data.data)
            })
            .catch(err => {
                // console.log(err)
                setLoading(false)
                cogoToast.error('Something went wrong while fetching details!')
            })
    }
    // console.log(documentData);
    
    // useEffect(() => {
    //     if (company?.id)
    //         getAllDocsByIssuer()
    // }, [company])

    // useEffect(() => {
    //     if (doc?.id)
    //         getAllDefaultDocId()
    // }, [doc])

    async function getAllIssuers() {
        setLoading(true)
        API.get(GET_ALL_COMPANIES+`?company_type=Issuer`) //change to distinct issuer
            .then(res => {
                setLoading(false)
                if (res.data.status === 200) {
                    setIssuers(res.data.data)
                }
            })
            .catch(err => {
                setLoading(false)
                cogoToast.error(err.message)
            })
    }

    const getBanner=()=>{
        API.get(GET_VERIFIER_BANNER)
        .then(res=>{
            setShowBanner(res.data.data.is_active)
            setNewBannerText(res.data.data.message)
            

        })        
        .catch(err=>{
            cogoToast.error(err.response.data.detail)


        })
    }


    useEffect(()=>{
        getBanner()

    },[])

    // async function getAllDocsByIssuer() {
    //     setLoadshimmer(1)
    //     API.get(GET_ALL_DOCS_ISSUER_ID + company.id) //change to distinct documents
    //         .then(res => {
    //             if (res.data.status === 200) {
    //                 setDocuments(res.data.data)
    //             }
    //         })
    //         .catch(err => {
    //             cogoToast.error(err.message)
    //         })
    //         .finally(() => setLoadshimmer(0))
    // }

    // async function getAllDefaultDocId() {
    //     setLoadshimmer(2)
    //     setresult([])
    //     setFormData(null)
    //     API.get(GET_DEFAULT_FIELDS + doc.id) //change to distinct documents
    //         .then(res => {
    //             if (res.data.status === 200) {
    //                 setDefaultFields(res.data.data)
    //             }
    //         })
    //         .catch(err => {
    //             cogoToast.error(err.message)
    //         })
    //         .finally(() => setLoadshimmer(0))
    // }

    // async function getSearchResults(api_data) {
    //     setLoadshimmer(3)
    //     let ls = []
    //     API.post(VERIFIER_SEARCH, api_data)
    //         .then(res => {
    //             if (res.data.status === 200) {
    //                 ls.push(res.data.data)
    //                 setresult(ls)
    //             }
    //         })
    //         .catch(err => {
    //             cogoToast.error(err.response.data.message)
    //         })
    //         .finally(() =>
    //             setLoadshimmer(false)
    //         )
    // }

    const Dropdown = ({ listType, list, selectedOption }) => {
        const [isOpen, setIsOpen] = useState(false);
        const dialogBox = useRef(null);
        const handleToggle = () => {
            setIsOpen(!isOpen);
        };

        useEffect(() => {
            const handleClickOutside = (event) => {
                if (dialogBox.current && !dialogBox.current.contains(event.target)) {
                    setIsOpen(false);
                }
            };
            document.addEventListener('click', handleClickOutside);
            return () => {
                document.removeEventListener('click', handleClickOutside);
            };
        }, []);

        if (listType == 0) {
            return (
                <div className={styles.letter} ref={dialogBox} style={{ width: '30rem' }}>
                    <div className={styles.lettertype} onClick={handleToggle} style={{ cursor: "pointer" }}>
                        <div className={styles.selectItem}>

                            <p> {selectedOption?.name ? selectedOption.name : 'Select Issuer'}</p>
                            {isOpen ? <img src='/chevrondown.svg' style={{ transform: "rotate(180deg)" }} /> : <img src='/chevrondown.svg' />}
                        </div>
                    </div>
                    <div className={styles.customDropdown} style={{ width: "inherit" }}>
                        {isOpen && (
                            <div className={styles.dropdownOptions} style={{ maxHeight: '20rem', overflowY: 'scroll' }}>
                                {list.map((i) => (
                                    <div key={i.id} className={styles.dropdownList} onClick={() => setCompany(i)}>
                                        {i.name}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            );
        }

    };
    const getTemplateFields=(document_id)=>{
        setLoading(true)
        API.get(GET_TEMPLATE_FIELDS_FOR_PREFILL,{
            params:{
                issuer_company_id:company.id,
                master_document_id:document_id
            }
        })
        .then(res=>{
            const EMPLOYMENT_TYPE_PATTERN = "^(Intern|Full-time|Trainee)$"
            const isEmploymentTypeField = (field) => {
                const labelMatches = typeof field.label === "string" && field.label.trim() === "Employment Type"
                const validatorMatches = field.validators === EMPLOYMENT_TYPE_PATTERN
                return labelMatches || validatorMatches
            }
            const isValidEmploymentTypeValue = (value) =>
                typeof value === "string" && new RegExp(EMPLOYMENT_TYPE_PATTERN).test(value)

            const shouldPrefill = company.employment_type_enabled && isValidEmploymentTypeValue(employmentType)

            const mappedTemplateData = res.data.data.fields.map(item => {
                const mapped = {
                    ...item,
                    value: item.default_value || "",
                    isRequired: item.is_required,
                }
                if (shouldPrefill && isEmploymentTypeField(mapped)) {
                    return { ...mapped, value: employmentType, disabled: true }
                }
                if (isDateOption(mapped)) {
                    return { ...mapped, fieldType:3 }
                }
                return mapped
            })
            const hideFields=["Employee Id","Name"]
            setLoading(false)
            setMasterTemplateId(res.data.data.master_template_id)
            setTemplateFields(mappedTemplateData.filter(field=>!hideFields.includes(field.label)))
        })
        .catch(err=>{
            setLoading(false)
            cogoToast.error(err.response?.data?.message)
            
        })
    }
    const submitData = () => {
        if(documentData.search_type!=="blue_collar"){
        if (company.length < 1) {
            cogoToast.info('Please select Issuer')
            return
        }

        if (!onbehalf) {
            cogoToast.info('Please select Behalf')
            return
        }
        if (onbehalf.company_name=="OTHERS" && !Other) {
            cogoToast.info('Please Enter Other')
            return
        }
        if (User.internal_user && arsNo=="") {
            cogoToast.info('Please Enter ARS No')
            return
        }
        if (company.employment_type_enabled && !employmentType) {
            cogoToast.info('Please Select Employement Type')
            return
        }
    }
        let url="";
        let api_data={};
        // if(documentData.search_type=="white_collar"){
            url=SEARCH_EMP_RECORDS;
            api_data={
                name: fieldsData.find(field=>field.field_name==="name")?.value || "",
                // email: fieldsData.find(field=>field.field_name==="email_id")?.value || "",
                // phone_number: fieldsData.find(field=>field.field_name==="phone_number")?.value || "",
                employee_id:fieldsData.find(field=>field.field_name==="employee_id")?.value || "",
                issuer_company_id:company.id,
                // master_doc_ids:documentData.required_documents.map(doc=> doc.master_document_id),
                verifier_id:id,
                search_type:"white_collar",
                on_behalf_of:onbehalf.company_id,
                other_company_name:Other
            }
            if(company.name=="Walmart Global Technology Services India Private Limited"){
                api_data.gts_id=fieldsData.find(field=>field.field_name==="gts_id")?.value || ""
            }
            if(company.employment_type_enabled){
                api_data.employment_type=employmentType
            }
        // }
        // else if(documentData.search_type==="blue_collar"){
        //     url=SEARCH_EMP_RECORDS;
        //     api_data={
        //         name: fieldsData.find(field=>field.field_name==="name")?.value || "",
        //         email: fieldsData.find(field=>field.field_name==="email_id")?.value || "",
        //         phone_number: fieldsData.find(field=>field.field_name==="phone_number")?.value || "",
        //         aadhar_last_three_digits:fieldsData.find(field=>field.field_name==="aadhar_last_three_digits")?.value || "",
        //         pan_last_five_digits: fieldsData.find(field=>field.field_name==="pan_last_five_digits")?.value || "",
        //         date_of_birth: fieldsData.find(field=>field.field_name==="date_of_birth")?.value || "",
        //         issuer_id:company.id,
        //         master_doc_ids:documentData.required_documents.map(doc=> doc.master_document_id),
        //         verifier_id:id,
        //         search_type:documentData.search_type
        //     }
        // }
        // else{
        //     url="/api/v1/issuer/get_issued_doc_id_by_notification_info/";
        //     api_data = {
        //         name: fieldsData.find(field => field.field_name === "name")?.value || "",
        //         email: fieldsData.find(field => field.field_name === "email_id")?.value || "",
        //         phone_number: fieldsData.find(field => field.field_name === "phone_number")?.value || "",
        //         issuer_id: company.id,
        //         // master_doc_ids: documentData.required_documents.map(doc => doc.master_document_id)
        //     };
    // }
        API.post(url, api_data)
            .then(res => {
                setresult(res.data.data)
                if(!res.data.data[0]?.record_found){
                    setIsRecordFound(res.data.data[0]?.record_found)
                    getTemplateFields(res.data.data[0]?.master_document_id)
                    setIsDataSearched(true)
                }
                // console.log(res.data.data)
            }
            )
            .catch(err => {
                setresult(null)
                cogoToast.info(err.response.data.message)
            })
    }
         
    
    return (
        <SlideUpWrapper direction="slide-right">
            {/* <IssuerNavigator
                title={"Verify User"}
                step={'/dashboard/emp/packages'}
                actions={() => null}
            /> */}
            <TopTitleBar isChild><h2 className='topTitlebarText'>Verify Users</h2></TopTitleBar>
           {showPopup && <CartPopupModel/>}

        {showBanner&&        
         <div  dangerouslySetInnerHTML={{ __html: newBannerText }}>
            {/* <h2>
                Raise an Appeal
            </h2>
            <p style={{fontSize:"16px"}}>To raise an appeal, please send an email to authnumber-support@authbridge.com with:</p>
            <ul>
            <li style={{margin:"5px 0px"}}>The details provided by us, and</li>
            <li style={{margin:"5px 0px"}}>The specific details for which you are raising the appeal, along with proper supporting documents.</li>
            </ul> */}
        </div>}
            {documentData.search_type==="blue_collar"?null:
            <section className={styles.searchBox} style={{ padding: '1rem', overflow:"visible" }}>
                <div className={styles.MainSearchContainer}>
                    <h2 className='topTitleBarText'style={{width:"100px"}}>
                        Select Employer:<span style={{ color: 'red' }}>*</span>
                    </h2>
                    <div className={styles.selectdocument}>
                        {loading ? <ShimmerLoader mt="0.6rem" height='2.4rem' /> :
                        <SearchDropdown value={company}  apidata={Issuers} displayKey="name" placeholder='Start Typing...' onSelect={(e)=>setCompany(e)}/>

                        }
                    </div>
                    <CompanySearch setOnBehalf={setOnBehalf} onbehalf={onbehalf} setOther={setOther} other={Other} />

                </div>
                {
                        User.internal_user&&
                        <div className={styles.MainSearchContainer}>
                        <h2 className='topTitleBarText' style={{marginRight:"10px"}}>
                        ARS No:<span style={{ color: 'red' }}>*</span>
                    </h2>
                        <input type='text' className={styles.input} placeholder='eg. 9876-54321' value={arsNo} style={{width:"29rem"}} onChange={(e)=>setArsNo(e.target.value)}/>
                        </div>
                        }
                        {
                        company.employment_type_enabled &&
                        <div className={styles.MainSearchContainer}>
                       <h2 className='topTitleBarText'style={{width:"100px"}}>
                        Employment Type:<span style={{ color: 'red' }}>*</span>
                    </h2>
                        <div style={{ display: "flex", gap: "2rem", alignItems: "center" }}>
                            <label style={{ display: "flex", alignItems: "center", gap: "0.5rem", cursor: "pointer" }}>
                                <input
                                    type='radio'
                                    name='employmentType'
                                    value='Intern'
                                    checked={employmentType === 'Intern'}
                                    onChange={(e) => setEmploymentType(e.target.value)}
                                    disabled={IsDataSearched}
                                />
                                Intern
                            </label>
                            <label style={{ display: "flex", alignItems: "center", gap: "0.5rem", cursor: "pointer" }}>
                                <input
                                    type='radio'
                                    name='employmentType'
                                    value='Full-time'
                                    checked={employmentType === 'Full-time'}
                                    onChange={(e) => setEmploymentType(e.target.value)}
                                    disabled={IsDataSearched}
                                />
                                Full-time
                            </label>
                            <label style={{ display: "flex", alignItems: "center", gap: "0.5rem", cursor: "pointer" }}>
                                <input
                                    type='radio'
                                    name='employmentType'
                                    value='Trainee'
                                    checked={employmentType === 'Trainee'}
                                    onChange={(e) => setEmploymentType(e.target.value)}
                                    disabled={IsDataSearched}
                                />
                                Trainee
                            </label>
                        </div>
                        </div>
                        }
            </section>
            }
            {/* <section className={styles.searchBox} style={{ padding: '1rem' }} >
                <FormDropdown document={documentData} />
            </section> */}

            {/* <section className={styles.searchBox} style={{ padding: '1rem' }} >
                <h2 className='topTitleBarText'>
                    Enter Recipient Details
                </h2> */}
            <RecipientsDetails id={1} fieldsData={fieldsData} setFieldsData={setFieldsData} submitData={submitData} setresult={setresult}  verifier_id={User.id} issuer_company={company.name || ""} templateFields={templateFields} setTemplateData={setTemplateFields} recordFound={isRecordFound} submitTrigger={isSubmit} setIsFormValid={setIsFormValid} DataSearch={IsDataSearched} setIsDataSearch={setIsDataSearched} setRecordFound={setIsRecordFound}/>
            {/* </section> */}
            {
                result &&
                <DisplayResult result={result} documentData={documentData} setFieldsData={setFieldsData} setresult={setresult} fieldsData={fieldsData} company={company} verifier_id={User.id}  onbehalf={onbehalf} issuer_company={company.name||""} other_company_name={Other} setShowPopup={setShowPopup} ARSNo={arsNo} recordFound={isRecordFound} setIsRecordFound={setIsRecordFound} templateData={templateFields} setTemplateData={setTemplateFields} submitTrigger={isSubmit} setSubmitTrigger={setIsSubmit} formValid={isFormValid} setIsFormValid={setIsFormValid} templateId={masterTemplate_id} employmentType={employmentType} />
            }
            <div className="credentials-table">
            </div>
        </SlideUpWrapper>
    )
}
